import { t, locale } from '../i18n'
import { convertPlanAmount } from './planCurrencies'

// Complete fallback feature matrix for production plans created before the
// public plans API exposed feature text. Higher tiers explicitly contain all
// capabilities from the tiers before them, followed by their additions.
const STARTER_FEATURES = [
  'Your own subdomain + basic theme',
  'POS, orders and printed bills',
  'Loyalty points',
  'QR codes for tables and flyers',
  'Card, bank transfer or cash payments',
  'Simple sales reports',
  'Email and WhatsApp support',
]

const GROWTH_ADDITIONS = [
  'Your own subdomain + full design control',
  'Staff accounts with roles and page access',
  'Kitchen screen and new-order alerts',
  'Inventory and low-stock alerts',
  'Accounting and sales reports',
  'Live WhatsApp support',
]

const BUSINESS_ADDITIONS = [
  'Your own domain or subdomain',
  'Menu, online store and bookings together',
  'Custom roles for every team member',
  'Live website editor',
  'Full finance and staff reports',
  'Dedicated 24/7 account manager',
]

export const fallbackPlanFeatures = index => {
  if (index === 0) return STARTER_FEATURES
  if (index === 1) return [...STARTER_FEATURES, 'Plus:', ...GROWTH_ADDITIONS]
  return [...STARTER_FEATURES, 'Plus:', ...GROWTH_ADDITIONS, 'Plus:', ...BUSINESS_ADDITIONS]
}

// How a platform plan reads on the website and at sign-up.
export const planPrice = (plan, displayCurrency) => {
  const currency = displayCurrency || (plan.currency || 'USD').toUpperCase()
  return new Intl.NumberFormat(locale(), {
    style: 'currency', currency, maximumFractionDigits: currency === 'OMR' || currency === 'KWD' || currency === 'BHD' ? 3 : 2,
  }).format(convertPlanAmount(plan, currency))
}

export const planServicesText = plan => (plan.max_services == null
  ? t('All services in one store')
  : plan.max_services === 1 ? t('Choose one service') : t('Choose {n} services in one store', { n: plan.max_services }))

export const planUsersText = plan => (plan.max_users == null
  ? t('Unlimited users')
  : plan.max_users === 1 ? t('1 user (you)') : t('Up to {n} users', { n: plan.max_users }))

// A feature line ending in ":" ("Everything in the previous plan, plus:") is a heading.
export const isHeading = feature => /:\s*$/.test(feature)

// The middle plan of three (or the last of two) is highlighted.
export const featuredIndex = plans => (plans.length >= 3 ? 1 : plans.length - 1)
